/** Figma 17019:877989, 17005:435988 e 17005:436039. */
export const PROJECAO_INCLUIDA_TITLE = "Projeção incluída";
export const PROJECAO_INCLUIDA_TEXTO =
  "A projeção financeira do escopo macro vai junto, recalculada no período e com a cotação da Obra de destino.";
export const AJUSTAR_PROJECAO_LABEL = "Ajustar projeção";
export const PROJECAO_AJUSTADA_TAG = "Projeção ajustada";
